import { LeftNavLinksQuery } from 'generated/types/gatsby'
import { graphql, Link, useStaticQuery } from 'gatsby'
import React from 'react'
import './left-nav.scss'

export const LeftNav = () => {
  const data = useStaticQuery<LeftNavLinksQuery>(graphql`
    query LeftNavLinks {
      allMdx(
        filter: { fields: { sourceName: { eq: "cards" } } }
        sort: { fields: frontmatter___sort }
      ) {
        edges {
          node {
            frontmatter {
              links {
                path
                title
                top
              }
              title
            }
          }
        }
      }
    }
  `)
  return (
    <div className="la-left-nav">
      {data.allMdx.edges.map((edge) => {
        return edge.node.frontmatter.links ? (
          <label key={edge.node.frontmatter.title} className="la-left-nav__item">
            <input
              type="radio"
              name="nav"
              value={edge.node.frontmatter.title}
              className="la-left-nav__item-input"
            />
            <div className="la-left-nav__item-label">{edge.node.frontmatter.title}</div>
            <div className="la-left-nav__item-link-set la-left-nav-link-set">
              {edge.node.frontmatter.links.map(
                (link) =>
                  link.top && (
                    <Link
                      className="la-left-nav-link-set__item la-link"
                      to={`/${edge.node.frontmatter.title}/${link.path}`}
                      key={link.title}
                    >
                      {link.title}
                    </Link>
                  )
              )}
              <Link
                className="la-left-nav-link-set__item la-link"
                to={`/${edge.node.frontmatter.title}`}
              >
                See more...
              </Link>
            </div>
          </label>
        ) : null
      })}
    </div>
  )
}
